module.exports = __webpack_public_path__ + "img/doctorDetail.b22299e2.png";